import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";

export default function useVolunteerShopList() {
  const { baseurl, token, setIsUnauthorised, AdminId } =
    useGlobalContext();

  const [volunteerShops, setVolunteerShops] = useState([]);
  const [filteredVolunteerShops, setFilteredVolunteerShops] = useState([]);
  const [loading, setLoading] = useState(false);

  // =========================
  // FETCH SHOP LIST
  // =========================
  const fetchVolunteerShops = async () => {
    setLoading(true);

    try {
      const res = await axios.post(
        `${baseurl}/api/VolunteerShop/v1.0/getVolunteerShopList`,
        {
          adminId: AdminId,
          userid: "",
        },
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      if (res.data?.responseCode === "00") {
        setVolunteerShops(res.data.data || []);
        setFilteredVolunteerShops(res.data.data || []);
      } else if (res.data?.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(
          res.data?.responseMessage ||
            "Failed to fetch volunteer shop list"
        );
      }
    } catch (err) {
      toast.error("Error fetching volunteer shop list");
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // ASSIGN SHOP TO VOLUNTEER
  // =========================
  const assignShopToVolunteer = async (volunteerId, shopId) => {
    try {
      const response = await axios.post(
        `${baseurl}/api/VolunteerUser/v1.0/assignShopToVolunteer`,
        {
          volunteerId,
          shopId,
        },
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.responseCode === "00") {
        toast.success("Shop assigned successfully");
        return true;
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
        return false;
      } else {
        toast.error(response.data.responseMessage);
        return false;
      }
    } catch (error) {
      toast.error("Something went wrong");
      return false;
    }
  };

  return {
    volunteerShops,
    filteredVolunteerShops,
    loading,
    fetchVolunteerShops,
    assignShopToVolunteer, 
  };
}
